import { Spinner } from "@next-platform/client-common-spicy-ui";
import type { ReactNode } from "react";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import { CREATION_TAB_META_PAGE_ID } from "@/pages/Creations/creationTabMetaPageId";
import useAuth from "@/services/useAuth";

import GroupChats from "./GroupChatsMy";

export const GroupChatsMy = () => {
  const { isLoading: isAuthLoading, isAuthenticated } = useAuth();

  let pageContent: ReactNode;
  if (isAuthLoading) {
    pageContent = <Spinner />;
  } else if (!isAuthenticated) {
    pageContent = <AnonymousMarketing datakey="creations" />;
  } else {
    pageContent = <GroupChats />;
  }

  return (
    <>
      <PageStaticMetaTags pageId={CREATION_TAB_META_PAGE_ID.groups} data-testid="GroupChatsMy-PageStaticMetaTags" />
      {pageContent}
    </>
  );
};
